
import React from 'react'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import WidthNormalIcon from '@mui/icons-material/WidthNormal'
import ClearIcon from '@mui/icons-material/Clear'

const ResetColumnWidths = ({ columnWidths, onResetWidths }) => {
  const theme = useTheme()
  const isColumnWidthsChanged = (columnWidths && Object.keys(columnWidths)?.length) ?? false
  return (
    <Tooltip title={isColumnWidthsChanged ? 'Reset Column Widths' : ''}>
      <IconButton
        sx={{
          color: isColumnWidthsChanged
            ? theme.palette.text.primary // Active columns color
            : theme.palette.text.tertiary, // Default gray color when no changes
          borderRadius: '0px',
        }}
        disabled={isColumnWidthsChanged ? false : true}
        onClick={onResetWidths}
      >
        <Badge
          badgeContent={
            <ClearIcon
              sx={{
                fontSize: '18px',
                color: isColumnWidthsChanged ? theme.palette.text.error : theme.palette.text.secondary,
              }}
            />
          }
        >
          <WidthNormalIcon
            sx={{
              fontSize: '30px',
              color: isColumnWidthsChanged ? theme.palette.text.primary : theme.palette.text.secondary, // Active filters color
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default ResetColumnWidths
